import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CreatedTransaction from "./CreatedTransaction";
import styles from '../styling/History.module.css'

function History() {
    const dispatch = useDispatch()
    const [history, setHistory] = useState([])

    const transactions = useSelector(state => state.transactions)

    const getHistory = () =>  {
        let array = []
        for (let key in transactions) {
        transactions[key].map((transaction, i) => array.push(<CreatedTransaction {...transaction} key={key + '_' + i} category={key} />) )
    }
        return array
    }

    useEffect(() => {
        setHistory(getHistory())
        // eslint-disable-next-line
    }, [transactions])

    const handleClick = () => {
        dispatch({
            type: 'transactions/clearTransactions',
        })
    }

    

    return (
        <section className={styles.section}>
            <h2 className={styles.h2} >Created Transactions</h2>
            <button className={styles.button} onClick={handleClick}>Clear All</button>
            <div className={styles.div} >
                { history }
            </div>
        </section>
    )

}

export default History;